import $ from 'jquery';

// const OFFSET = 150;

// $('a[href^="#"]').on('click', function(e) {
//     console.log('click');
//   const targetId = $(this).attr('href').substring(1);
//   const $target = $('#' + targetId);

//   if ($target.length) {
//     e.preventDefault();
//     const targetPosition = $target.offset().top - OFFSET;

//     $('html, body').animate({
//       scrollTop: targetPosition
//     }, 500); // czas scrollowania w ms
//   }
// });



    function initFooterAccordion() {
        if ($(window).width() <= 600) {

            $('.footer__mid--menut').off('click').on('click', function() {
                const $parent = $(this).closest('.footer__mid--col');
                const $menu = $parent.find('.footer__mid--menu');
                const $arrow = $(this).find('.footer__vector');

                $menu.stop(true, true).slideToggle(200);
                $arrow.toggleClass('active');
            });

        } else {
            // reset na desktopie
            $('.footer__mid--menu').show();
            $('.footer__vector').removeClass('active');
            $('.footer__mid--menut').off('click');
        }
    }

    initFooterAccordion();

    $(window).on('resize', function(){
        initFooterAccordion();
    });

